let cacheComponent
import FullscreenConfirm from "@pathwright/ui/src/components/confirm/FullscreenConfirm"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { getContentManageMethods } from "library/show/components/content/manage/methods/utils"
import PropTypes from "prop-types"
import React from "react"
import { blocks as blocksMethod } from "../blocks/manage/methods"
import ManageContentBlank from "./ManageContentBlank"
import "./ManageContentContainer.css"
import ManageContentEditor from "./ManageContentEditor"
import ManageContentHeader from "./ManageContentHeader"
import ManageContentPreview from "./ManageContentPreview"

class ManageContentContainer extends React.PureComponent {
  render() {
    const {
      // config
      prompt,
      // props
      methods,
      step,
      content,
      isEditing,
      activeMethod,
      forceChooseBlocks,
      // actions
      editContent,
      editMethod,
      clearMethod,
      exitEditor
    } = this.props

    // we don't render empty states anymore with blocks
    if (!content) return null

    return (
      <div className="ManageContent__Container">
        {forceChooseBlocks && (
          <FullscreenConfirm
            {...blocksMethod.confirm}
            onConfirm={() => {
              return editMethod("blocks")
            }}
            hideCancel
          />
        )}

        {activeMethod ? (
          <ManageContentHeader
            step={step}
            methods={methods}
            activeMethod={activeMethod}
            onSelectMethod={editMethod}
            onClearMethod={clearMethod}
            onEdit={editContent}
            isEditing={isEditing}
          />
        ) : undefined}
        {content && activeMethod ? (
          isEditing ? (
            <ManageContentEditor
              methods={methods}
              step={step}
              activeMethod={activeMethod}
              onSelectMethod={editMethod}
              onClearMethod={clearMethod}
              onExitEditor={exitEditor}
            />
          ) : (
            <ManageContentPreview
              methods={methods}
              activeMethod={activeMethod}
              step={step}
              content={content}
              onEdit={editContent}
            />
          )
        ) : (
          <ManageContentBlank
            prompt={prompt}
            methods={methods}
            onSelectMethod={editMethod}
          />
        )}
      </div>
    )
  }
}

ManageContentContainer.displayName = "ManageContentContainer"

ManageContentContainer.propTypes = {
  prompt: PropTypes.string.isRequired,
  methods: PropTypes.objectOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      prompt: PropTypes.string.isRequired
      // form: React.PropTypes.func.isRequired # can't do element or node?
    }).isRequired
  ).isRequired,
  method: PropTypes.string
}

const mapStateToProps = function (state, ownProps) {
  let { content, step } = state.stepStore.state
  const { method, selection } = state.contentAdminStore.state
  const {
    selectContent,
    selectNewContent,
    selectMethod,
    clearMethod,
    clearContent,
    selectBlocksContent
  } = state.contentAdminStore.action

  const editContent = () =>
    // NOTE: content.type can be stale if step type was just updated
    // For instance, content will save as reading even though step was just
    // changed to submission. When the page is reloaded the content will
    // fail to load.
    selectContent(content.type, content)

  const editMethod = function (method) {
    if (method === "blocks" && !step.content) {
      step.content = { type: "blocks" }
    }
    if (!selection) {
      // See content.type note above ^
      const contentType = step.content
        ? step.content.type
        : step.assignment_type
      selectNewContent(contentType)
    }
    return method === "blocks" ? selectBlocksContent() : selectMethod(method)
  }

  const exitEditor = () => clearContent()

  const isEditing = selection != null

  let activeMethod = content !== null ? content.method : method

  content = isEditing ? selection : content

  // If no active method is selected, we need to prompt user to choose blocks.
  const forceChooseBlocks = !activeMethod

  if (!activeMethod) {
    const methods = getContentManageMethods(step.assignment_type)
    // Default to first method. Just for rendering purposes.
    activeMethod = Object.keys(methods)[0]
  }

  const methods = getContentManageMethods(step.assignment_type, activeMethod)

  const props = _.assign({}, ownProps, {
    // state
    step,
    methods,
    content,
    isEditing,
    activeMethod,
    // actions
    editContent,
    selectBlocksContent,
    editMethod,
    exitEditor,
    clearMethod,
    forceChooseBlocks
  })

  return props
}

const stores = [
  { store: "step", watch: ["step", "content"] },
  { store: "contentAdmin", watch: ["method", "selection"] }
]

export default ConnectStores(
  ManageContentContainer,
  stores,
  {},
  mapStateToProps,
  (cacheComponent = false)
)
